import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';

export const Step2Wix: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				// alignItems: 'center',
				// justifyContent: 'center',
				mt: '20px',
				gap: '40px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						The store can&apos;t be connected directly from the Dashboard.
					</Typography>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						To connect your Wix store please follow these instructions:{' '}
						<Link
							href="https://help.easproject.com/hc/en-gb/articles/5026187301407"
							target="_blank"
							rel="noreferrer"
							sx={{
								color: '#016193',
								fontSize: '1rem',
								fontWeight: 'bold',
								textDecoration: 'none',
								'&:hover': {
									textDecoration: 'underline',
								},
							}}
						>
							Configuring Wix Store.
						</Link>
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
